// Animated Lottie icons (from design Drive). Imported as JSON animation data.
import home from './home.json';
import cards from './cards.json';
import wallet from './wallet.json';
import chart from './chart.json';
import user from './user.json';
import txReceive from './tx-receive.json';
import txSend from './tx-send.json';
import txTopup from './tx-topup.json';
import txSwap from './tx-swap.json';
import txError from './tx-error.json';
import txComission from './tx-comission.json';
import dollarAdd from './dollar-add.json';

export const lottie = {
  home,
  cards,
  wallet,
  chart,
  user,
  txReceive,
  txSend,
  txTopup,
  txSwap,
  txError,
  txComission,
  dollarAdd,
};
